export default function jobsSearchUrlHelper(inputParams, loggedIn, address) {
  const filterParams = new URLSearchParams();
  if (inputParams && inputParams.search) {
    filterParams.append('search', inputParams.search);
  }
  if (inputParams && inputParams.op_id) {
    filterParams.append('op_id', inputParams.op_id);
  }
  if (inputParams && inputParams.activities) {
    inputParams.activities.split(',').forEach((value) => {
      filterParams.append('activity[]', value.trim());
    });
  }
  if (inputParams && inputParams.tags) {
    inputParams.tags.split(',').forEach((value) => {
      filterParams.append('tagsOr[]', value.trim());
    });
  }
  if (
    inputParams &&
    inputParams.distance &&
    loggedIn &&
    address &&
    address.latitude &&
    address.longitude &&
    address.geoCluster
  ) {
    filterParams.append(
      'distance',
      `${address.latitude},${address.longitude},${inputParams.distance}`
    );
    filterParams.append('whereInput', address.geoCluster);
  }
  return decodeURI(filterParams.toString()) + '&isPublished=1';
}
